export default __webpack_public_path__ + "static/media/buy_fxdx_bond.8e72a10c.svg";